module.exports = __webpack_public_path__ + "static/media/remove-filter-icon.85b6496d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/remove-filter-icon.svg
// module id = 58
// module chunks = 0